export default {
  "content": "<path d=\"M7.004 9h4.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-3.5V3.51c0-.28-.22-.5-.5-.5s-.5.22-.5.5V9z\"/><path fill-rule=\"evenodd\" d=\"M8.004 16c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zm7-8c0 3.87-3.13 7-7 7s-7-3.13-7-7 3.13-7 7-7 7 3.13 7 7z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};